import * as api from "@/services/api";
import { arrayToObject } from "@/services/helpers";

export const createBulkDiscount = async ({ commit }, payload) => {
  try {
    const response = await api.post("/bulk-discounts", payload);
    commit("bulkDiscountAdded", response.data);
    return "success";
  } catch (error) {
    commit(
      "ui/setSnackbar",
      { variant: "danger", title: "Error", message: error.response?.data?.message || "Problem Creating Bulk Discount" },
      { root: true },
    );
    return error;
  }
};

export const updateBulkDiscount = async ({ commit }, { id, ...payload }) => {
  try {
    const response = await api.patch(`/bulk-discounts/${id}`, payload);
    commit("replaceBulkDiscount", response.data);
    return "success";
  } catch (error) {
    commit(
      "ui/setSnackbar",
      { variant: "danger", title: "Error", message: error.response?.data?.message || "Problem Updating Bulk Discount" },
      { root: true },
    );
    return error;
  }
};

export const fetchBulkDiscounts = async ({ commit }) => {
  try {
    const response = await api.get("/bulk-discounts");
    const bulkDiscounts = arrayToObject(response.data, "id");
    commit("initBulkDiscounts", bulkDiscounts);
  } catch (error) {
    commit("ui/setSnackbar", { variant: "danger", title: "Error", message: "Error Fetching Bulk Discount List" }, { root: true });
  }
};

export const destroyBulkDiscount = async ({ commit, dispatch }, payload) => {
  try {
    const response = await api.destroy(`/bulk-discounts/${payload}`);
    if (response.data.message == "success") {
      commit("bulkDiscountRemoved", payload);
    } else {
      commit("ui/setSnackbar", { variant: "danger", title: "Error", message: "Error Deleting Bulk Discount" }, { root: true });
    }
  } catch (error) {
    commit("ui/setSnackbar", { variant: "danger", title: "Error", message: "Error Deleting Bulk Discount" }, { root: true });
  }
};
